module.exports = __webpack_public_path__ + "static/media/fb-login.d212fc89.svg";